import { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { LayoutSplashScreen } from "../../../../_metronic/layout";
import { persistor } from "../../../../redux/store";
import { removeLocalStorage } from '../../../helpers/LocalStorage';
import * as auth from "../_redux/authRedux";
import { submitLogoutToAuthService } from "../_redux/authCrud";
import { cancelPendingCallbackSession } from "../_redux/pendingCallbackSession";
import { clearCache } from "../../../services/reactQuery";
import { resetSegmentIdentity } from "../../../services/tracking/segmentIdentity";
import { POST_LOGIN_REDIRECT_KEY } from "../../../constants/postLoginRedirect";

function clearSessionLeftovers() {
  cancelPendingCallbackSession();

  sessionStorage.removeItem(POST_LOGIN_REDIRECT_KEY);

  try {
    resetSegmentIdentity();
  } catch (error) {
  }

  removeLocalStorage('group');
  removeLocalStorage('oab_monitoring_filter_selected');
  clearCache();
}

function Logout({ hasAuthToken, idToken, logout, logoutRequested }) {
  const [delegating] = useState(() => auth.isAuthServiceSession({ idToken }));
  const [delegationFailed, setDelegationFailed] = useState(false);
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) {
      return;
    }
    startedRef.current = true;

    clearSessionLeftovers();

    if (!delegating) {
      logoutRequested();
      return;
    }

    (async () => {
      logout();
      try {
        await persistor.flush();
        submitLogoutToAuthService({ idToken });
      } catch (error) {
        console.error("[auth] logout: auth-service logout unavailable", {
          reason: error?.message,
        });
        setDelegationFailed(true);
      }
    })();
  }, [delegating, idToken, logout, logoutRequested]);

  const isWaitingForAuthService = delegating && !delegationFailed;

  if (isWaitingForAuthService || hasAuthToken) {
    return <LayoutSplashScreen />;
  }

  return <Redirect to="/auth/login" />;
}

export default connect(
  ({ auth }) => ({ hasAuthToken: Boolean(auth.authToken), idToken: auth.idToken }),
  { logout: auth.actions.logout, logoutRequested: auth.actions.logoutRequested }
)(Logout);
